'use client'

import SectionSwiper from '@component/layout/section/swiper'
import NewsStandard from '@component/card/news/standard'

export default function CommercialNewsContent({
  data
}) {

  return (
    <SectionSwiper data={data} dataKey='id' Card={NewsStandard}></SectionSwiper>
  )
}